import { useTableView } from "@/hooks";
import { Flex, Text, ButtonGroup, Button } from "@chakra-ui/react";
import { MdGridOn, MdOutlineList } from "react-icons/md";

function TableViewToggle() {
  const { view, setView } = useTableView();
  return (
    <Flex gap="2" ml="auto" alignItems="center" textAlign="right">
      <Text fontSize="xs">View</Text>
      <ButtonGroup variant="outline" size="xs" colorPalette="blue" attached>
        <Button
          onClick={() => setView("grid")}
          variant={view === "grid" ? "solid" : "outline"}
        >
          <MdGridOn /> Grid
        </Button>
        <Button
          onClick={() => setView("list")}
          variant={view === "list" ? "solid" : "outline"}
        >
          <MdOutlineList /> List
        </Button>
      </ButtonGroup>
    </Flex>
  );
}
export default TableViewToggle;
